import { render, staticRenderFns } from "./ShowMoreButton.vue?vue&type=template&id=c61f916e&"
import script from "./ShowMoreButton.vue?vue&type=script&lang=ts&"
export * from "./ShowMoreButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports